import { Pipe, PipeTransform } from "@angular/core";
import { CaseDocumentModel } from "../models/case-document.model";

@Pipe({
    name: "attachmentFilter"
})
export class AttachmentFilterPipe implements PipeTransform {
    
    public transform(documents: CaseDocumentModel[], attachmentGroupId:string): CaseDocumentModel[] {
        
        if(documents){            
 
            let arr = documents.filter(
                item => {
                    return item.CaseEventId == attachmentGroupId;
                }
            )
    
            return arr;    
        }
        return documents;
    }
}